import { competitionRegistrationModal } from './../competitionRegistration/competitionRegistration.component';
import { Component, OnInit, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../services/data/data.service';

@Component({
  selector: 'mobile-competition-registration-modal',
  template: require('./mobile-competition-registration-modal.component.html'),
  styles: [require('./mobile-competition-registration-modal.component.css')]
})
export class MobileCompetitionRegistrationModalComponent extends competitionRegistrationModal {

  constructor(
    protected router: Router,
    protected fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public dataService: DataService,
    injector: Injector,
  ) {
    super(router, fb, activeModal, dataService, injector);
  }

}
